import { alpha } from '@material-ui/core/styles';
import { styled } from '../../../core/theme/styled';

export const StyledSummary = styled.summary`
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.sizes.normal};
  cursor: pointer;
  :focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.configuration.primaryColor, 0.25)};
  }
  border-radius: ${(props) => props.theme.roundedCorners.medium};
`;

export const StyledAccordionDetails = styled.details`
  color: ${(props) => props.theme.configuration.buttonBackgroundColor};
  background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
  border-radius: ${(props) => props.theme.roundedCorners.medium};
  summary::marker,
  summary::-webkit-details-marker {
    display: none;
  }
`;

export const DetailsBody = styled.div`
  padding: 0 ${(props) => props.theme.sizes.normal} ${(props) => props.theme.sizes.normal};
`;
